import { defineMessages } from 'react-intl';

export const MESSAGES = defineMessages({
    title: {
        defaultMessage: 'Modules',
        id: 'iaso.modules.title',
    },
    name: {
        defaultMessage: 'Name',
        id: 'iaso.label.name',
    },
    codename: {
        defaultMessage: 'Code name',
        id: 'iaso.label.codename',
    },
    status: {
        defaultMessage: 'Status',
        id: 'iaso.modules.status',
    },
    search: {
        defaultMessage: 'Search',
        id: 'iaso.search',
    },
    created_at: {
        defaultMessage: 'Created',
        id: 'iaso.label.created_at',
    },
    updated_at: {
        defaultMessage: 'Updated',
        id: 'iaso.label.updated_at',
    },
    data_collection_forms: {
        defaultMessage: 'Data collection - Forms',
        id: 'iaso.modules.data_collection_forms',
    },
    default: {
        defaultMessage: 'Default',
        id: 'iaso.modules.default',
    },
    dhis2_mapping: {
        defaultMessage: 'DHIS2 mapping',
        id: 'iaso.modules.dhis2_mapping',
    },
    embedded_links: {
        defaultMessage: 'Embedded links',
        id: 'iaso.modules.embedded_links',
    },
    entities: {
        defaultMessage: 'Entities',
        id: 'iaso.modules.entities',
    },
    external_storage: {
        defaultMessage: 'External storage',
        id: 'iaso.modules.external_storage',
    },
    planning: {
        defaultMessage: 'Planning',
        id: 'iaso.modules.planning',
    },
    polio_project: {
        defaultMessage: 'Polio project',
        id: 'iaso.modules.polio_project',
    },
    registry: {
        defaultMessage: 'Registry',
        id: 'iaso.modules.registry',
    },
    payments: {
        defaultMessage: 'Payments',
        id: 'iaso.modules.payments',
    },
    completeness_per_period: {
        defaultMessage: 'Completeness per Period',
        id: 'iaso.modules.completeness_per_period',
    },
    modulesInformation: {
        id: 'iaso.modules.modulesInformation',
        defaultMessage:
            'You can see here the feature modules that are activated for your account. Contact an admin of your instance if you wish to activate additional features.',
    },
    trypelim_project: {
        defaultMessage: 'Trypelim project',
        id: 'iaso.modules.trypelim_project',
    },
    data_validation: {
        defaultMessage: 'Data validation',
        id: 'iaso.modules.data_validation',
    },
    saas: {
        defaultMessage: 'SaaS',
        id: 'iaso.modules.saas',
    },
    stock_management: {
        defaultMessage: 'Stock management',
        id: 'iaso.modules.stock_management',
    },
    snt_malaria: {
        defaultMessage: 'SNT Malaria',
        id: 'iaso.modules.snt_malaria',
    },
    form_ai: {
        defaultMessage: 'Form AI',
        id: 'iaso.modules.form_ai',
    },
});

export default MESSAGES;
